import { InAppMessageView } from "../view/InAppMessageView"
import { InAppMessageViewEvent } from "./InAppMessageViewEvent"
import { InAppMessageViewEventHandlerFactory } from "./InAppMessageViewEventHandler"
import { InAppMessageViewEventHandleType } from "./InAppMessageViewEventHandleType"

export class InAppMessageViewEventHandleProcessor {
  constructor(private readonly handlerFactory: InAppMessageViewEventHandlerFactory) {}

  process(view: InAppMessageView, event: InAppMessageViewEvent, types: InAppMessageViewEventHandleType[]): void {
    types.forEach((type) => {
      const handler = this.handlerFactory.get(type)
      handler?.handle(view, event)
    })
  }
}
